import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { Group, CreateGroupDto, UpdateGroupDto, EquipmentConfig, ServerConfig, Certificates } from '@/types'

export const groupsService = {
  getAll: async (): Promise<Group[]> => {
    return apiClient.get<Group[]>(API_ENDPOINTS.GROUPS.BASE)
  },

  getById: async (id: string): Promise<Group> => {
    return apiClient.get<Group>(API_ENDPOINTS.GROUPS.BY_ID(id))
  },

  getEquipmentConfig: async (groupId: string): Promise<EquipmentConfig | null> => {
    return apiClient.get<EquipmentConfig | null>(API_ENDPOINTS.GROUPS.EQUIPMENT(groupId))
  },

  updateEquipmentConfig: async (
    groupId: string,
    config: EquipmentConfig
  ): Promise<EquipmentConfig | null> => {
    return apiClient.patch<EquipmentConfig | null>(API_ENDPOINTS.GROUPS.EQUIPMENT(groupId), config)
  },

  getServerConfig: async (groupId: string): Promise<ServerConfig | null> => {
    return apiClient.get<ServerConfig | null>(API_ENDPOINTS.GROUPS.SERVER(groupId))
  },

  updateServerConfig: async (
    groupId: string,
    config: ServerConfig
  ): Promise<ServerConfig | null> => {
    return apiClient.patch<ServerConfig | null>(API_ENDPOINTS.GROUPS.SERVER(groupId), config)
  },

  getCertificates: async (groupId: string): Promise<Certificates | null> => {
    return apiClient.get<Certificates | null>(API_ENDPOINTS.GROUPS.CERTIFICATES(groupId))
  },

  updateCertificates: async (
    groupId: string,
    certificates: Certificates
  ): Promise<Certificates | null> => {
    return apiClient.patch<Certificates | null>(
      API_ENDPOINTS.GROUPS.CERTIFICATES(groupId),
      certificates
    )
  },

  create: async (data: CreateGroupDto): Promise<Group> => {
    return apiClient.post<Group>(API_ENDPOINTS.GROUPS.BASE, data)
  },

  update: async (id: string, data: UpdateGroupDto): Promise<Group> => {
    return apiClient.patch<Group>(API_ENDPOINTS.GROUPS.BY_ID(id), data)
  },

  delete: async (id: string): Promise<void> => {
    return apiClient.delete<void>(API_ENDPOINTS.GROUPS.BY_ID(id))
  },
}

